<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <form [formGroup]="form">
    <div>
      <span><b>Concessionária</b></span>
      <div class="grid grid-cols-3 gap-3 mt-3">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Código</mat-label>
          <input matInput type="text" formControlName="code" />
        </mat-form-field>
        <app-select-form-field
          label="Montadora (OE)"
          [control]="automaker"
          [options]="automakers"
          [display]="companyDisplayName"
        />
      </div>
    </div>

    <div class="mt-3">
      <app-company-form
        #companyForm
        [states]="states"
        [parentFormGroup]="form"
      />
    </div>

    <div class="mt-3">
      <span><b>Outras Informações</b></span>
      <div class="grid grid-cols-2 gap-3 mt-3">
        <app-select-form-field
          label="LB"
          [control]="productLine"
          [options]="productLines"
          [display]="productLineDisplayName"
        />
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Classificação</mat-label>
          <textarea matInput micScrollBar rows="1" formControlName="classification"></textarea>
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Distributor</mat-label>
          <input matInput type="text" formControlName="distributor"/>
        </mat-form-field>
      </div>
    </div>

    <div class="mt-3">
      <div class="flex flex-row mt-3 gap-4">
        <mat-checkbox formControlName="active">Ativo</mat-checkbox>
        <!-- <mat-checkbox formControlName="deleted">Excluido</mat-checkbox> -->
      </div>
    </div>
  </form>
</mic-spinner-overlay>
